import fetch from "isomorphic-fetch";
import _ from "lodash";
import {newNotification} from "./notifications";
import { API2_URL, RESOURCE_CONCEPT_FETCH, RESOURCE_CONCEPT_REQUEST, RESOURCE_CONCEPT_FAIL } from "../store/config";
import {sessionService} from "redux-react-session";

export const resourceConceptsList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				dispatch(resourceConceptsRequest());

				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				return fetch(`${API2_URL}/resources/concepts`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(resourceConceptsData(json)),
						error => {
							dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}))
							return dispatch(resourceConceptsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
}

const resourceConceptsData = (json) => {
	return {
		type: RESOURCE_CONCEPT_FETCH,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		timestamp: Date.now()
	}
}

const resourceConceptsFail = (error) => {
	return {
		type: RESOURCE_CONCEPT_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}

const resourceConceptsRequest = () => {
	return {
		type: RESOURCE_CONCEPT_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}


// WEBPACK FOOTER //
// ./src/actions/resource_concept.js